import { TranslateService } from '@ngx-translate/core';

export function AppInitializer(translateService: TranslateService) {
  translateService.addLangs(['de', 'en']);
  translateService.use('de');

  return true;
}
